import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class BuildingUnitsModel {
    incomeRestricted: number = null;
    marketRate: number = null;
    stabilized: number = null;
    rentControlled: number = null;
    permanentExempt: number = null;
    totalUnits: number = null;


    constructor(model?: Partial<BuildingUnitsModel>) {
        if (model && model !== undefined) {
          const def = new BuildingUnitsModel();
          Object.keys(def).forEach((key: string) => {
            this[key] = model[key] !== null && model[key] !== undefined ?
              model[key] : def[key];
          });
        }
      }

    static asForm(fb: FormBuilder): FormGroup {
        return fb.group({
            incomeRestricted: [],
            marketRate: [],
            stabilized: ['', Validators.required],
            rentControlled: [],
            permanentExempt: [],
            totalUnits: [{value: 0, disabled: true}]
        });
    }

    static generateForm(fb: FormBuilder, model: BuildingUnitsModel): FormGroup {
        const form = BuildingUnitsModel.asForm(fb);
        form.setValue(model);
        return form;
    }

    static convertFormToModel(form: FormGroup): BuildingUnitsModel {
        return form.value;
    }
}

